import { render, staticRenderFns } from "./VideoEditorMultiStep.vue?vue&type=template&id=73fdd299"
import script from "./VideoEditorMultiStep.vue?vue&type=script&lang=js"
export * from "./VideoEditorMultiStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73fdd299')) {
      api.createRecord('73fdd299', component.options)
    } else {
      api.reload('73fdd299', component.options)
    }
    module.hot.accept("./VideoEditorMultiStep.vue?vue&type=template&id=73fdd299", function () {
      api.rerender('73fdd299', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/VideoEditorMultiStep.vue"
export default component.exports